import { render } from "./PurchaseOrdersView.vue?vue&type=template&id=dcbf78e6&scoped=true"
import script from "./PurchaseOrdersView.vue?vue&type=script&lang=js"
export * from "./PurchaseOrdersView.vue?vue&type=script&lang=js"

import "./PurchaseOrdersView.vue?vue&type=style&index=0&id=dcbf78e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcbf78e6"]])

export default __exports__